module.exports = __webpack_public_path__ + "img/photo-13.11bef95c.jpg";